import {
  FuelType,
  Vehicle,
  VehicleCategory,
  VehicleType,
} from "@b2bportal/ground-api";

export const getVehicleCategoryLabel = (category: VehicleCategory) => {
  switch (category) {
    case VehicleCategory.CompactElite:
      return "Compact Elite";
    case VehicleCategory.EconomyElite:
      return "Economy Elite";
    case VehicleCategory.FullsizeElite:
      return "Fullsize Elite";
    case VehicleCategory.Intermediate:
      return "Midsize";
    case VehicleCategory.IntermediateElite:
      return "Midsize Elite";
    case VehicleCategory.LuxuryElite:
      return "Luxury Elite";
    case VehicleCategory.MiniElite:
      return "Mini Elite";
    case VehicleCategory.PremiumElite:
      return "Premium Elite";
    case VehicleCategory.StandardElite:
      return "Standard Elite";
    case VehicleCategory.Compact:
    case VehicleCategory.Economy:
    case VehicleCategory.Fullsize:
    case VehicleCategory.Luxury:
    case VehicleCategory.Mini:
    case VehicleCategory.Oversize:
    case VehicleCategory.Premium:
    case VehicleCategory.Special:
    case VehicleCategory.Standard:
    case VehicleCategory.Unspecified:
    default:
      return category;
  }
};

export const getVehicleTypeLabel = (type: VehicleType) => {
  switch (type) {
    case VehicleType.CommercialVanTruck:
      return "Commercial Van/Truck";
    case VehicleType.LimousineSedan:
      return "Limousine/Sedan";
    case VehicleType.MotorHome:
      return "Motor Home";
    case VehicleType.OpenAirAllTerrain:
      return "Open Air All Terrain";
    case VehicleType.PassengerVan:
      return "Passenger Van";
    case VehicleType.PickUpDoubleCab:
    case VehicleType.PickUpSingleExtendedCar:
      return "Pick Up";
    case VehicleType.RecreationalVehicle:
      return "Recreational Vehicle";
    case VehicleType.SpecialCar:
    case VehicleType.SpecialOfferCar:
      return "Car";
    case VehicleType.SportsCar:
      return "Sports Car";
    case VehicleType.TwoWheelVehicle:
      return "2 Wheel Vehicle";
    case VehicleType.WagonEstate:
      return "Wagon/Estate";
    case VehicleType.Car:
    case VehicleType.Convertible:
    case VehicleType.Coupe:
    case VehicleType.Crossover:
    case VehicleType.Monospace:
    case VehicleType.Roadster:
    case VehicleType.SUV:
    case VehicleType.Unspecified:
    default:
      return type;
  }
};

const FUEL_TYPES_TO_DISPLAY: FuelType[] = [FuelType.Electric, FuelType.Hybrid];

export const getVehicleClassLabelFromVehicle = (vehicle: Vehicle) => `${getVehicleCategoryLabel(vehicle.category)}${
    FUEL_TYPES_TO_DISPLAY.includes(vehicle.fuelType)
      ? ` ${vehicle.fuelType} `
      : " "
  }${getVehicleTypeLabel(vehicle.vehicleType)}`;
